import classNames from 'classnames'
import Textfield from 'shared/components/Textfield'

import styles from '../styles.module.scss'

const FlightInfo = ({
    bookingData,
    setOutboundNumber,
    setInboundNumber,
    outboundNumberError,
    setOutboundNumberError,
    inboundNumberError,
    setInboundNumberError,
    locationData,
}) => (
    <div className={classNames('p-4 p-sm-0', styles.flightInfoSection)}>
        <h5 className="mb-5">
            <T>booking.flight.info.label</T>
        </h5>
        <div className="d-flex flex-column flex-sm-row">
            {locationData.isOutboundFlight && (
                <div className="w-100 px-0">
                    <Textfield
                        name="outboundNumber"
                        value={bookingData.outboundNumber}
                        required
                        onChange={e => setOutboundNumber({ outboundNumber: e.currentTarget.value })}
                        label={<T>booking.outbound.flight.number.label</T>}
                        minLength={1}
                        maxLength={10}
                        setShowError={setOutboundNumberError}
                    />
                    {outboundNumberError && (
                        <div className="mt-2 error-text">
                            <T>booking.outbound.input.invalid</T>
                        </div>
                    )}
                </div>
            )}
            {locationData.isInboundFlight && (
                <div className="w-100 mt-4 mt-sm-0 ml-sm-5">
                    <Textfield
                        name="inboundNumber"
                        className={''}
                        value={bookingData.inboundNumber}
                        onChange={e => setInboundNumber({ inboundNumber: e.currentTarget.value })}
                        label={<T>booking.inbound.flight.number.label</T>}
                        required
                        minLength={1}
                        maxLength={10}
                        setShowError={setInboundNumberError}
                    />
                    {inboundNumberError && (
                        <div className="mt-2 error-text">
                            <T>booking.inbound.input.invalid</T>
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>
)

export default FlightInfo
